import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  IonModal,
  ToastController,
  LoadingController,
  NavController,
  IonInput
} from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { CurrencyPipe } from '@angular/common';
import { AuthService } from 'src/app/service/auth.service';
import { ClientResponse } from 'src/app/shared/clientResponse.model';
import { Client } from 'src/app/shared/client.model';
import { Order } from 'src/app/shared/order.model';
import { OrderDetail } from 'src/app/shared/orderDetail.model';
import { OrderResponse } from 'src/app/shared/orderResponse.model';
import { OrderDetailResponse } from 'src/app/shared/orderDetailResponse.model';
import { SendMessage } from 'src/app/shared/sendMessage.model';
import { SendMessageResponse } from 'src/app/shared/sendMessageResponse.model';
import { AdminService } from 'src/app/service/admin.service';
import { Constant } from "../../shared/model/Constant";
import { environment } from "src/environments/environment";
import { OrderService } from 'src/app/service/order.service';


@Component({
  selector: 'app-purchase-order',
  templateUrl: './create-order.page.html',
  styleUrls: ['./create-order.page.scss'],
})
export class PurchaseOrderPage implements OnInit {
  @ViewChild('documentFocus', { static: false }) focusDocument!: IonInput;
  @ViewChild('focusNameProduct', { static: false }) focusNameProduct!: IonInput;
  @ViewChild('fieldFocus', { static: false }) fieldFocus!: IonInput;
  @ViewChild(IonModal) modal: IonModal;
  focusIsSet!: boolean;
  userId: string;
  client: Client;
  clientId: number;
  orderId: number;
  secondName: string;
  firstName: string;
  firstLastName: string;
  secondLastName: string;
  amount: string;
  discount: string = "$0.00";
  quantity: string;
  auxamount: number = 0;
  auxdiscount: number = 0;
  totalDiscount: number = 0;
  totalAmount: number = 0;
  subtotalAmount: number = 0;
  nameProduct: string;
  category: string;

  email: string;
  validEmail: boolean = true;
  validPhone: boolean = true;
  validWhatsapp: boolean = true;
  phone: number;
  document: string;
  typeDoc: number;
  formDisabled: boolean;
  showConfirm: boolean = false;
  showMessage: boolean = false;
  message: string = "";
  image: string = "";
  order: Order;
  isFormClientComplete: boolean = false;
  isFormProductComplete: boolean = false;
  loading: any;
  orderDetail: OrderDetail;
  orderDetailList: OrderDetail[] = [];
  detailorderResponse: OrderDetailResponse[] = [];
  sendCelular: string;
  sendwhatsapp: string;
  whatsappCel: number;
  typeSend: string;
  documents: any;
  icono: string;

  constructor(private currencyPipe: CurrencyPipe,
    private authService: AuthService,
    private orderService: OrderService,
    private adminService: AdminService,
    public toastController: ToastController,
    public loadingController: LoadingController,
    private nav: NavController) {
    this.formDisabled = true;

  }



  async ngOnInit() {
    this.userId = localStorage.getItem(Constant.userId);
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 5000
    });
    this.focusDocument.setFocus();

    this.adminService.getTypeIdentificationId().subscribe((res: any) => {
      this.documents = res;
    });
  }

  typeDocumentChange(ev: any) {
    this.typeDoc = ev.target.value;
    this.document = null;
    this.clearClient();

  }

  async createOrder() {
    if (!this.isFormClientComplete) {
      this.presentToast('Los datos mandatorios del cliente no estan completos.');
      return;
    }

    if (!this.isFormProductComplete) {
      this.presentToast('No se han agregado productos a la compra.');
      return;
    }

    if (this.totalAmount < 100000 || this.totalAmount > 3000000) {
      this.presentToast('El valor total de la compra no está permitido, debe ser mayor de $100.000 y menor de $3.000.000.');
      return;
    }

    if (!this.clientId) {
      this.client = new Client();
      this.client.firstName = this.firstName;
      this.client.identificationTypeId = this.typeDoc;
      this.client.firstLastName = this.firstLastName;
      this.client.secondName = this.secondName;
      this.client.secondLastName = this.secondLastName;
      this.client.document = this.document;
      this.client.celular = this.phone;
      this.client.whatsapp = this.whatsappCel;
      this.client.mail = this.email;
      this.client.registeredBy = this.userId;
      this.authService.addClient(this.client).subscribe((res: ClientResponse) => {
        this.clientId = res.clientId;
        this.sendCelular = res.celular ? String(res.celular).substring(0, 1) + '****' + String(res.celular).substring(5, String(res.celular).length) : null;
        this.sendwhatsapp = res.whatsapp ? String(res.whatsapp).substring(0, 1) + '****' + String(res.whatsapp).substring(5, String(res.whatsapp).length) : null;
        // this.formDisabled = true;
        this.sendOrder();
      }, error => {
        console.warn('Error consulta cliente ', error);
        this.document = null;
        this.clearClient();
        this.presentToast('No se encuentra cliente con este documento, valida los datos por favor.');
      });
    } else {
      this.sendOrder();
    }
  }

  clearOrder() {
    this.clearClient();
    this.formDisabled = false;
    this.detailorderResponse = null;
    this.orderId = null;
    this.detailorderResponse = null;
    this.orderDetailList = null;
  }

  close() {
    this.showConfirm = false;
    if (this.image === "ok") {
      window.location.href = '/listOrders';
    } else {
      this.showMessage = false;
      this.showConfirm = true;
    }
  }

  closeModal() {
    this.showConfirm = false;
    window.location.href = '/listOrders';
  }

  checkTypeSend(tipo: string) {
    console.warn('tipo selected ', tipo);
    this.typeSend = tipo;
  }

  async sendOrderAndFinish() {
    const loading = await this.loadingController.create({
      message: 'Enviando Orden..',
      spinner: 'bubbles',
      duration: 100000
    });
    await loading.present();
    var sendMessage = new SendMessage();
    sendMessage.to = "+57" + this.phone;
    sendMessage.message = "Hola!! estimado cliente para continuar con el proceso de compra este es el link de pago "      //se agrega el mensaje al front debido a que estaba en el backend de integrations-ms y se requiere usar el servicio para otras funcionalidades
      + environment.web.orderUri + this.orderId + " ";

    console.warn(this.typeSend);
    switch (this.typeSend) {
      case 'SMS': { //
        this.authService.sendSMS(sendMessage).subscribe((res: SendMessageResponse) => {
          if (res.status) {
            this.presentToast('Mensaje Enviado SMS.');
            loading.dismiss();
            this.showMessage = true;
            this.message = "ENVÍO DE LINK EXITOSO. ";
            this.image = "ok";
            this.icono = "arrow-forward-circle-outline";
          }
        }, error => {
          console.warn('Error enviando mensaje ', error);
          this.presentToast('Error enviando mensaje.');
          loading.dismiss();
          this.showMessage = true;
          this.message = "FALLO EL ENVÍO DE LINK DE PAGO, POR FAVOR REENVIAR NUEVAMENTE. ";
          this.image = "error"
          this.icono = "arrow-back-circle-outline";
        });
        break;
      };
      case 'WSP': {
        this.authService.sendWathsapp(sendMessage).subscribe((res: SendMessageResponse) => {
          if (res.status) {
            this.presentToast('Mensaje Enviado WSP.');
            loading.dismiss();
            this.showMessage = true;
            this.message = "ENVÍO DE LINK EXITOSO. ";
            this.image = "ok";
            this.icono = "arrow-forward-circle-outline";
          }
        }, error => {
          console.warn('Error enviando mensaje ', error);
          loading.dismiss();
          this.showMessage = true;
          this.message = "FALLO EL ENVÍO DE LINK DE PAGO, POR FAVOR REENVIAR NUEVAMENTE. ";
          this.image = "error"
          this.icono = "arrow-back-circle-outline";
        });
        break;
      };
      default: {
        this.authService.sendSMS(sendMessage).subscribe((res: SendMessageResponse) => {
          if (res.status) {
            loading.dismiss();
            this.showMessage = true;
            this.message = "ENVÍO DE LINK EXITOSO. ";
            this.image = "ok";
            this.icono = "arrow-forward-circle-outline";
          }
        }, error => {
          console.warn('Error enviando mensaje ', error);
          loading.dismiss();
          this.showMessage = true;
          this.message = "FALLO EL ENVÍO DE LINK DE PAGO, POR FAVOR REENVIAR NUEVAMENTE. ";
          this.image = "error"
          this.icono = "arrow-back-circle-outline";
        });
        break;
      }

    }
  }

  async sendOrder() {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 100000
    });
    await loading.present();
    this.order = new Order();
    this.order.idUser = Number(this.userId);
    this.order.client = new Client();
    this.order.client.clientId = this.clientId;
    this.order.amount = this.totalAmount;
    this.order.totalDiscount = this.totalDiscount;
    this.order.orderDetail = this.orderDetailList;

    this.orderService.addOrder(this.order).subscribe((res: OrderResponse) => {
      this.orderId = Number(res.idOrder);
      this.detailorderResponse = res.orderDetail;
      if (this.orderId) {
        loading.dismiss();
        this.presentToast('Orden Creada exitosamente .....');
        this.showConfirm = true;
      }
    }, error => {
      console.warn('Error creando la orden ', error);
      this.formDisabled = false;
      loading.dismiss();
      this.presentToast('No se logro crear la orden, valida los datos e intenta de nuevo por favor.');
    });
  }

  clearClient() {
    this.firstName = null;
    this.secondName = null;
    this.firstLastName = null;
    this.secondLastName = null;
    this.phone = null;
    this.whatsappCel = null;
    this.email = null;
    this.isFormClientComplete = false;
  }

  confirm() {
    this.showConfirm = false;
  }

  onWillDismiss(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    // if (ev.detail.role === 'confirm') {

    // }
  }

  validateMail() {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
      this.validEmail = true;
    } else {
      this.validEmail = false;
    }
  }

  validatePhone() {
    setTimeout(() => {
      if (this.phone !== null && this.phone !== undefined) {
        const phoneString = this.phone.toString();

        if (phoneString.length === 10) {
          this.validPhone = true;
        } else {
          this.validPhone = false;
          this.isFormClientComplete = false;
        }
      } else {
        this.validPhone = false;
        this.isFormClientComplete = false;
      }
    }, 0);

  }
  validateWhatsapp() {
    setTimeout(() => {
      if (this.whatsappCel !== null && this.whatsappCel !== undefined) {
        const whatsappCelString = this.whatsappCel.toString();

        if (whatsappCelString.length === 10) {
          this.validWhatsapp = true;
        } else {
          this.validWhatsapp = false;
          this.isFormClientComplete = false;
        }
      } else {
        this.validWhatsapp = false;
        this.isFormClientComplete = false;
      }
    }, 0);
  }

  validateOnlyNumbers() {

    if (this.document) {
      this.document = String(this.document).replace(/\D/g, '');
    }
    if (this.phone) {
      this.phone = Number(String(this.phone).replace(/\D/g, ''));
    }
    if (this.whatsappCel) {
      this.whatsappCel = Number(String(this.whatsappCel).replace(/\D/g, ''));
    }
    if (this.quantity) {
      this.quantity = this.quantity.replace(/\D/g, '');
    }
  }

  searchClient() {
    this.formDisabled = false;
    if (!this.typeDoc) {
      this.presentToast('Debe seleccionar un tipo de identificacion para buscar el cliente.');
      return;
    }

    this.authService.getClientByDocument(this.document).subscribe((res: ClientResponse) => {
      if (res) {
        if (this.typeDoc === res.identificationTypeId) {
          this.sendCelular = res.celular ? String(res.celular).substring(0, 1) + '****' + String(res.celular).substring(5, String(res.celular).length) : null;
          this.sendwhatsapp = res.whatsapp ? String(res.whatsapp).substring(0, 1) + '****' + String(res.whatsapp).substring(5, String(res.whatsapp).length) : null;
          this.phone = res.celular;
          this.firstName = res.firstName;
          this.firstLastName = res.firstLastName;
          this.secondName = res.secondName;
          this.secondLastName = res.secondLastName;
          this.email = res.mail;
          this.clientId = res.clientId;
          this.whatsappCel = res.whatsapp;
          this.isFormClientComplete = true;
        } else {
          this.clearClient();
          this.presentToast('El cliente no existe, complete los datos por favor.');
        }
      } else {
        this.clearClient();
        this.presentToast('El cliente no existe, complete los datos por favor.');
      }
      this.fieldFocus.setFocus();
    }, error => {
      console.warn('Error consulta cliente ', error);
      this.clearClient();
      this.presentToast('No se encuentra cliente con este documento, valida los datos por favor.');
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 2000,
      position: 'top',
      mode: 'ios',
      color: 'primary'
    });
    toast.present();
  }

  validateOnlyAmount() {
    try {
      if (this.amount) {
        let amountNumber = this.amount.split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxamount = Number(amountNumber.split(".").join(''));
        this.amount = this.currencyPipe.transform(this.auxamount, 'COP', 'symbol-narrow', '1.0-0');
      }
      if (this.discount) {
        let discountNumber = this.discount.split("$").join('');
        discountNumber = discountNumber.split(",").join('');
        this.auxdiscount = Number(discountNumber.split(".").join(''));
        console.log("this.auxdiscount");
        console.log(this.auxdiscount);
        this.discount = this.currencyPipe.transform(this.auxdiscount, 'COP', 'symbol-narrow', '1.0-0');
      } else {
        this.discount = "$0";
      }

    } catch (error) {
      console.log("Error en valor: " + error);
    }
  }

  validateOnlyLetters() {
    if (this.secondName) {
      this.secondName = String(this.secondName).replace(/[^a-zA-Z ]/g, '').substring(0, 20);
    }
    if (this.secondLastName) {
      this.secondLastName = String(this.secondLastName).replace(/[^a-zA-Z ]/g, '').substring(0, 20);
    }
    if (this.firstLastName) {
      this.firstLastName = String(this.firstLastName).replace(/[^a-zA-Z ]/g, '').substring(0, 20);
    }
    if (this.firstName) {
      this.firstName = String(this.firstName).replace(/[^a-zA-Z ]/g, '').substring(0, 20);
    }
    if (this.nameProduct) {
      this.nameProduct = String(this.nameProduct).replace(/[^a-zA-Z ]/g, '').substring(0, 20);
    }
  }

  accordionGroupChange = async (ev: any) => {

    if (!this.isFormClientComplete) {
      if (this.typeDoc
        && this.document
        && this.firstName
        && this.phone
        && this.whatsappCel
        && this.firstLastName
        && this.validPhone
        && this.validWhatsapp
      ) {
        this.isFormClientComplete = true;
      } else {
        this.isFormClientComplete = false;
      }
    }

    if (this.orderDetailList.length > 0) {
      this.isFormProductComplete = true;
    } else {
      this.isFormProductComplete = false;
    }

  };

  addProduct() {

    if (this.nameProduct && this.quantity && this.auxamount) {

      this.totalAmount = Number(this.totalAmount) + (Number(this.auxamount) * Number(this.quantity));
      this.subtotalAmount = this.totalAmount;
      this.totalAmount = this.totalAmount - this.auxdiscount;
      this.totalDiscount = this.totalDiscount + this.auxdiscount;
      this.orderDetail = new OrderDetail(
        this.nameProduct,
        this.category,
        this.auxdiscount,
        Number(this.quantity),
        Number(this.auxamount)
      );
      this.orderDetailList.push(this.orderDetail);
      this.nameProduct = null;
      this.category = null;
      this.discount = null;
      this.quantity = null;
      this.amount = null;
      this.auxdiscount = 0;
      this.auxamount = 0;
      this.focusNameProduct.setFocus();
    } else {

      this.presentToast('No se adicionó la información necesaria para el producto, por favor validar.');
    }


  }

  deleteProduct(index: number) {
    this.totalAmount = Number(this.totalAmount) - (Number(this.orderDetailList[index].value) * Number(this.orderDetailList[index].quantity));
    this.totalAmount = this.totalAmount + Number(this.orderDetailList[index].discount);
    this.subtotalAmount = this.totalAmount;
    this.totalDiscount = this.totalDiscount-Number(this.orderDetailList[index].discount);
    this.orderDetailList.splice(index, 1);
    if (this.orderDetailList.length > 0) {
      this.isFormProductComplete = true;
    } else {
      this.isFormProductComplete = false;
    }
  }

}
